/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import isNil from 'lodash/isNil';
import isNumber from 'lodash/isNumber';

import ViewerDelayer from './viewer-delayer';

// TODO Unit testy.
/**
 * Továrna na správce zpoždění.
 */
export default class ViewerDelayerFactory {
  /**
   * Vytvoří instanci.
   * @param {Object} [opts={}] Nepovinné parametry.
   * @param {number} [opts.delay] Zpoždění, které se aplikuje při detekovaném zacyklení.
   * @param {number} [opts.limit] Počet selhání v řadě, který se považuje za zacyklení.
   */
  constructor({ delay, limit } = {}) {
    if (!isNil(delay) && !isNumber(delay)) {
      throw new TypeError(`Invalid delay ${delay}.`);
    }
    if (!isNil(limit) && !isNumber(limit)) {
      throw new TypeError(`Invalid limit ${limit}.`);
    }
    this.delay = delay;
    this.limit = limit;
  }

  /**
   * Vytvoří nového správce zpoždění.
   * @returns {ViewerDelayer} Vytvořený správce zpoždění.
   */
  create() {
    return new ViewerDelayer({ delay: this.delay, limit: this.limit });
  }
}
